import { getMetaData } from './pos-service-type-utils';
import { EMERALD_SS_CONFIG } from './profiles/emerald-ss-config';
import { R10_CONFIG } from './profiles/r10-config';
import { ServiceType } from './service-type';

export interface IUiConfiguration {
  showBuID: boolean;
  showScanMessage: boolean;
  productName: string;
  browserTitle: string;
  showPasswordLabel: boolean;
  separateApprovalRequest: boolean;
  showPhoneNumberOnCustomerSearch: boolean;
  showStatusOnCustomerSearch: boolean;
  recallInterventionsSupported: boolean;
  fullCartResponse: boolean;
  behaviorLookupRequest: boolean;
  callPriceQueryOnPluItem: boolean;
  showQuantityOnItemVoidedLine: boolean;
  allowModifyTareForWeightedItems: boolean;
  interventionsSuspendOnCancel: boolean;
  checkEndorsement: boolean;
  /**
   * Represents a value indicating whether pre tender add should check for full equality between
   * pre tender lines before cancelling a pre tender payment to replace it with a new one.
   * Otherwise only tender ids and auth status will be compared
   */
  preTenderFullEquality: boolean;
  groupedCouponSummary: boolean;
  voidAllCouponsOnVoidTransaction: boolean;
  /**
   * Represents a value indicating whether valid tenders were get at the cashier login or during checkout
   * Selling service do not process valid tenders and tenders come from selling config as same value, thus it set as false
   * If transactions items determines the valid tenders, like R10 does, set it to true.
   */
  dynamicTender: boolean;
  /*
  R10 will make an RTI call for finish transaction,
  but Emerald doesn't
  */
  finishTransactionOnlyWhenBalanceDueZero: boolean;
  callGetEffectiveTaxRates: boolean;
  mergeBrmInputs: boolean;
  showZeroUnusedCoupons: boolean;
  showZeroIssuedCoupons: boolean;
  showPreDefinedOptionsForTareWeightItem: boolean;
  /*
  Determine weather to validate "letters only" on first/last name fields in Customer Search screen
  */
  validateLettersOnlyOnSearchForm: boolean;
  manualTareAlwaysEnabled: boolean;
  registrationAuthenticationSupported: boolean;
  serverSideExitTrainingMode: boolean;
  showCustomerSearchTotals: boolean;
  /*
  Determine specific steps needed to process eft and ewic tenders
  */
  requiresPreTenderInitAndCancel: boolean;
  resendPreTenderOnce: boolean;
  requiresDecodePrescription: boolean;
  requiresTPSCallsForEft: boolean;
  requiresTPSCallsForEwic: boolean;
  requiresGetFinalRxBalance: boolean;
  requiresCancelPreTenderFromCart: boolean;
  validateAlternateId: boolean;
  requiresAlternateTenderNotification: boolean;
  balancesWithEwicService: boolean;
  requiresGetTenderFromCart: boolean;

  hidePriceInPriceEntryDialog: boolean;
  allowModifyingTareForSingleGroupItem: boolean;
  sortBySequence: boolean;
  requiresUpdateTouchPoint: boolean;
  /*
  Emerald 2.0 and Emerald GX have different price override validation logic, so
  for some cases, we'll want to apply validations on client
  */
  runClientValidationWhenOverridingToHigherPrice: boolean;
  /*
   * Represents a value to indicate whether or not to balance the cart during a transaction
   * Emerald requires that you balance the cart in order to close the transaction,
   * or provide a refund and R10 does not
   */
  callBalanceAfterTenderAdd: boolean;
  showTareLinkedItemOnEJ: boolean;
  recallUpdateCartStatus: boolean;
  usePackIdentifier: boolean;
  voidItemWhenRejectIntervention: boolean;
  voidRejectInterventionsPreSolve: boolean;
  priceCheckDecode: boolean;
  callTlogInvalidPassword: boolean;
  separatePaymentOptionsObjectInTender: boolean;
  warmupPostLogin: boolean;
  useTrainingModeAPIs: boolean;
  allowPartialPaymentFromKeypad: boolean;
  useRefundToCalculateChange: boolean;
  callTlogTerminal: boolean;
  shouldPromptPhoneNumberWhenSwipeAhead: boolean;
  auditUserHeader: boolean;
  eftSignatureVerificationDialog: boolean;
  /*
   * When TenderNotAllowedForChange exception is thrown, we need to distinguish between
   * how Emerlad handle the error, and how Emerlad GX, regarding the displayed message.
   */
  shouldDisplayTenderNotAllowedForChangeErrorMessage: boolean;
  notifyShift: boolean;
  transactionLookupSupported: boolean;
  supportMsvRewards: boolean;
  alertWhenCustomerNotFound: boolean;
  /*
   * Emerald GX needs to cal CardIdentificationNotExpected, mainly when moving to No Sale mode, so swipe/tap won't be available.
   */
  shouldCallCardIdentificationNotExpected: boolean;
  getCustomerFromCartResponse: boolean;
  showEwicQuantityErrorMessage: boolean;
  disableLoyaltySearchOnTenderMode: boolean;
}

const ConfigMap = {
  R10: R10_CONFIG,
  EMERALD_SELLING_SERVICE: EMERALD_SS_CONFIG,
};

export function getXLRConfig(serviceType: ServiceType): IUiConfiguration {
  return ConfigMap[serviceType];
}

export function getCurrentXLRConfig(): IUiConfiguration {
  return getXLRConfig(getMetaData().serviceType);
}

/* NTEP Trade Scale Certification */
/* The environment variables are embedded during the build time  */
/* https://create-react-app.dev/docs/adding-custom-environment-variables/#adding-development-environment-variables-in-env */
/* Env vars must have prefix REACT_APP. During the build, process.env.REACT_APP_XXX will be replaced with the current value of the REACT_APP_XXX environment variable */
export function getCurrentSystemInfo(): string {
  return `NCR | MOD ${getCurrentXLRConfig().productName} | v${
    process.env.REACT_APP_VERSION
  } | CC No: 22-XXX`;
}
